import { Element } from '../../../../common/html/element'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { AdditionalInfo } from './AdditionalInfo'
import classes from './index.module.scss'
import { PaymentInfo } from './PaymentInfo'
import { ViewOption } from './ViewOption'

export const TotalInfo = () => {
  return (
    <Element className={classes.totalInfo}>
      <ScrollComponent>
        <Element className="h100 flexColumn" style={{ color: '#3A414B' }}>
          <AdditionalInfo />
          <ViewOption />
          <PaymentInfo />
        </Element>
      </ScrollComponent>
    </Element>
  )
}
